import { Button, Container, ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllPages, createPage } from "../../api/page";
import { SiteStateContext } from "../../contexts/SiteStateContext";
import { fixSiteState } from "../../util/site_state";
import AdminLayout from "./AdminLayout";

const AdminPages = () => {
    const { siteState, setSiteState } = useContext(SiteStateContext);
    const navigate = useNavigate();
    const [pages, setPages] = useState<BasicPageData[]>([]);
    const [creating, setCreating] = useState(false);

    useEffect(() => {
        if (setSiteState) {
            setSiteState(fixSiteState({ title: "Pages - Admin", navHighlight: "/admin/pages", adminPage: true }));
        }
    }, [setSiteState]);

    useEffect(() => {
        loadPages();
    }, []);

    const loadPages = () => {
        getAllPages()
            .then((pages) => {
                setPages(pages);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const handleCreatePage = async () => {
        setCreating(true);
        try {
            const newPage = await createPage({
                title: "New Page",
                slug: "new-page-" + Date.now(),
                content: "",
                blocks: JSON.stringify([]),
                navHighlight: "/new-page",
                navOrder: -1,
                live: false,
            } as any);
            navigate(`/admin/pages/${newPage.id}`);
        } catch (error) {
            console.error("Failed to create page:", error);
        } finally {
            setCreating(false);
        }
    };

    return (
        <AdminLayout>
            <Container sx={{ m: 0 }} maxWidth={false}>
                <Typography variant="h2" sx={{ mt: 2, mb: 4 }}>
                    Pages
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleCreatePage}
                    disabled={creating}
                    sx={{ mb: 3 }}
                >
                    {creating ? "Creating..." : "Create New Page"}
                </Button>
                <Typography variant="h4" sx={{ mt: 2, mb: 4 }}>
                    {pages.length} Pages
                </Typography>
                {/* List all pages */}
                {pages.map((page) => (
                    <ListItem key={page.id} disablePadding>
                        <ListItemButton
                            onClick={() => {
                                navigate(`/admin/pages/${page.id}`);
                            }}
                        >
                            <ListItemText primary={page.title} secondary={`${page.slug} (${page.live ? "published" : "draft"})`}/>
                        </ListItemButton>
                    </ListItem>
                ))}
            </Container>
        </AdminLayout>
    );
};

export default AdminPages;
